// Utils
// import AxiosClient from '../utils/api';
var RESOURCE_BASE_URL = '';
export var getResourceByType = function getResourceByType(resourceType, searchQuery) {
  return Promise.resolve([{
    id: 'hello',
    name: 'hello'
  }]);
}; //Axios.get(`${RESOURCE_BASE_URL}?type=${resourceType}`); // eslint-disable-line implicit-arrow-linebreak